export enum FirstDayWizardStep {
  None = 0,
  SetupYourFeed = 1,
  SetupYourBoard = 2,
  SetupLanguage = 3,
}
